// import React from "react";

// const Hero = () => {
//   return (
//     <section className="hero-section">
//       <div className="hero-overlay"></div>

//       <div className="hero-content text-center">
//         <h1>Ghayar Auto Spare Parts</h1>
//         <p>
//           is a leading e-commerce platform specializing
//           in providing a comprehensive range of spare parts for all types of
//           vehicles. Established in Dubai, UAE, we are committed to delivering
//           high-quality products with quick and safe delivery services.
//         </p>
//       </div>
//     </section>
//   );
// };

// export default Hero;
import React from "react";

const Hero = () => {
  return (
    <section className="hero-section">
      <video
        className="hero-video"
        src="/assets/videos/hero.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
    </section>
  );
};

export default Hero;
